import React from 'react';

function CloseSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      fill="none"
      viewBox="0 0 17 16"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1.742.213A.727.727 0 10.713 1.242L7.471 8 .713 14.758a.727.727 0 101.029 1.029L8.5 9.029l6.758 6.758a.727.727 0 001.029-1.029L9.529 8l6.758-6.758A.727.727 0 0015.259.213L8.5 6.971 1.742.213z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default CloseSvg;
